// extracted by mini-css-extract-plugin
module.exports = {"divider":"style_divider__2HHvC"};